/**
 * Created by shobhitjain on 15/01/20.
 */
import React from 'react';
import style from './index.scss';
import NoDataImage from '../../assets/no-data-found.png';

const NoDataToDisplay = () => {
  return (
    <div className={style.data_warning}>
      <img src={NoDataImage} />
      <p>No data to display</p>
    </div>
  );
};

export default NoDataToDisplay;
